import React from "react";
import { useSearchModalContext } from "contexts/SearchModalContext";

export const use404ModalOpener = () => {
    const { dispatch } = useSearchModalContext();

    const openModal = React.useCallback(
        (pathname: string) => {
            const pathParts = pathname.split("/").filter(Boolean);
            const lastPart = pathParts[pathParts.length - 1];

            // split on all non-alphanumeric characters
            const humanFriendlyQuery = lastPart
                .replace(".html", "")
                .split(/[^a-zA-Z0-9]+/g)
                .join(" ");

            dispatch({ type: "set_search_modal_open", value: true });
            dispatch({ type: "set_search_term", value: humanFriendlyQuery });
            dispatch({ type: "set_version_select_value", value: "all" });
            dispatch({ type: "set_is_404_search", value: true });
        },
        [dispatch]
    );

    return openModal;
};
